"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFonts = void 0;
const useFont_1 = __importDefault(require("./useFont"));
exports.useFonts = useFont_1.default;
